<template>
<DialogDisabler v-if="Saving & Access('CarsAdd')"></DialogDisabler>
<div v-if="Access('CarsAdd')" :id="'CookiesDialog_' + DialogIndex" class="CookiesDialogdBody">
  <div class="M-Auto DialogContainer">
    <div class="DialogBody">
      <div class=" D-Flex W-100" style="text-align:left; margin-bottom:15px; white-space: nowrap;">
      </div>
      <!-- Car -------------------------------------- -->
      <div class="CookiesRow" style="direction: ltr;">
         <div class="CookiesRow W-100"><span class="M-Auto O-50">{{$store.state.CookiesConfig.Language === 'ARA' ? 'رقم اللوحة': ''}}{{$store.state.CookiesConfig.Language === 'ENG' ? 'Plate Number': ''}}</span></div>
        <input maxlength="2" v-model="PlateNum_1" :class=" (ErrorsVisibilty & !PlateNum_1) && 'ErrorBorder'" class="CookiesInput color2" type="text" placeholder="" autocomplete="off" style="max-width: 2em; text-align: center;">
        <span class="M-Auto O-50 F2em">-</span>
        <input maxlength="6" v-model="PlateNum" :class=" (ErrorsVisibilty & !PlateNum) && 'ErrorBorder'" class="CookiesInput color2" type="text" placeholder="" autocomplete="off">
        <div class="CookiesRow W-100"></div>
        <div class="CookiesRowSplitter W-100"></div>
        <input :style="{direction: $store.getters.Direction}" v-model="Name" :class=" (ErrorsVisibilty & !Name) && 'ErrorBorder' " class="CookiesInput color2" type="Text" :placeholder="$store.state.CookiesConfig.Language === 'ARA' ? 'الاسم': '' + $store.state.CookiesConfig.Language === 'ENG' ? 'Name': ''" autocomplete="off">
      </div>
    </div>
  </div>
</div>
<div v-if="Access('CarsAdd')" class="CookiesDialogFooter">
  <div class=" F-Bold" style="margin: auto 1em;">
    <button @click="$router.go(-1)" style="background: var(--colorr1);;" class="F-Bold CookiesButton DialogFooterButton">{{$store.state.CookiesConfig.Language === 'ARA' ? 'الغاء': ''}}{{$store.state.CookiesConfig.Language === 'ENG' ? 'Cancel': ''}}</button>
    <button @click="SaveCar()" :style="'background: ' + $store.getters.Theme.UserColors.main" class="F-Bold CookiesButton DialogFooterButton">{{$store.state.CookiesConfig.Language === 'ARA' ? 'حفظ': ''}}{{$store.state.CookiesConfig.Language === 'ENG' ? 'Save': ''}}</button>
  </div>
</div>

</template>

<script>
export default {
  setup () {},
  components: {},
  created () {},
  data () {
    return {
      PlateNum_1: '',
      PlateNum: '',
      Email: '',
      Name: '',
      ErrorsVisibilty: false,
      Saving: false
    }
  },
  props: {
    DialogIndex: Number,
    DialogData: { default: '' }
  },
  methods: {
    SaveCar () {
      if (this.DialogError.length > 0) {
        this.ErrorsVisibilty = true
        return
      }
      this.Saving = true
      this.Post('POST', 'Cars', this.NewCarData).then(response => {
        this.Saving = false
        this.CloseDialog(this.DialogIndex)
      }, error => {
        this.Saving = false
        error.CookiesError = 'Error in Adding New Car'
        this.OpenDialog('ErrorDialog', 'Error', error) // [ Dialog Component Name, Dialog Header Text, Dialog Data tot pass ]
      })
    },
    CheckPlateNum_1 () {
      if (this.PlateNum_1 > 99) {
        this.PlateNum_1 = ''
      } else if (this.PlateNum_1 <= 0) {
        this.PlateNum_1 = ''
      }
    },
    CheckPlateNum () {
      if (this.PlateNum > 999999) {
        this.PlateNum = ''
      } else if (this.PlateNum <= 0) {
        this.PlateNum = ''
      }
    },
    ChangePassword () {
      this.OpenDialog('ChangePassDialog', 'Change Password', this.DialogData) // [ Dialog Component Name, Dialog Header Text, Dialog Data tot pass ]
    },
    EmailValidator (email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },
    AttributeArray (array, attribute) {
      var names = array.map(function (item) {
        return item[attribute]
      })
      return names
    }
  },
  mounted () {
    if (!this.Access('CarsAdd')) {
      return
    }
    try {
      var DialogPos = document.getElementById('CookiesDialog_' + this.DialogIndex).offsetTop - 60
      window.scrollTo(0, DialogPos)
    } catch (error) {
      console.log('error: ', error.message)
    }
  },
  computed: {
    NewCarData () {
      var PlateNum = this.PlateNum_1.toString() + '-' + this.PlateNum.toString()
      console.log(PlateNum)
      return {
        PlateNum: PlateNum,
        Type: 'Car',
        Name: this.Name
      }
    },
    DialogError () {
      var DialogErrors = []
      this.PlateNum === '' && DialogErrors.push('Please Enter Car\'s PlateNum')
      this.PlateNum_1 === '' && DialogErrors.push('Please Enter Car\'s PlateNum')
      this.Name === '' && DialogErrors.push('Please Enter Car\'s Phone')
      return DialogErrors
    },
    isActive () {
      return this.$store.state.CookiesMemory.D_NewCar_Active
    }
  }
}
</script>

<style scoped>
.DialogBody{
  width: 500px;
  max-width: 70vw;
}
.DialogContainer{
  padding: 50px;
}
@media (max-width: 500px) {
  .FlexBreaker{
    flex-direction: column;
  }
  .FlexBreaker > *{
    width: 80% !important;
  }
  .DialogContainer{
    padding: 1em;
  }
  .CookiesDialogdBody{
    font-size: 3vw;
  }
}
@media (max-width: 300px) {
  .CookiesDialogdBody{
    font-size: 4vw;
  }
}
.CookiesInputHolder{
  height: 30px;
  width: 200px;
  border: none;
  border-radius: var(--rad2);
  flex: auto;
  padding: 10px 25px;
  outline: none;
  font-size: 17px;
  margin: 6px;
  position: relative;
}

.CookiesInputInside::placeholder{
  opacity: 0.35;
}
.CookiesRowSpacer{
  width: 100%;
  height: 20px;
}

.CookiesNumberInput{
  display: flex;
  margin: auto;
  border-radius: var(--rad3);
  overflow: hidden;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.ErrorBorder{
  border: solid var(--colorr2) 2px;
  padding: 8px 23px;
}
</style>
